/* eslint-disable */
import * as React from "react";
import { AgGridReact } from "ag-grid-react";
import AgGridTableBaseTooltip from "./components/components/AgGridTableBaseTooltip";
import AgGridTableStandardTooltip from "./components/components/AgGridTableStandardTooltip";
import cn from "classnames";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css"; //ag-theme-material
import { GridReadyEvent, GridOptions, ColDef, RowDataChangedEvent, GridApi } from "ag-grid-community";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import merge from "lodash/merge";

export const BASE_TOOLTIP_COMPONENT_ID = "BaseTooltip";
export const STANDARD_TOOLTIP_COMPONENT_ID = "StandardTooltip";
export const TABLE_LOADED_CLASS = "ag-theme-data-loaded";
export const TABLE_LOADING_CLASS = "ag-theme-data-loading";
export const TOOLTIP_ANIMATION_CLASS = "animate";
const TOOLTIP_ANIMATION_DURATION = 0.2;
const CHANGE_DATA_TIMEOUT = 0.3;

const styles = (theme: Theme) =>
  createStyles({
    root: {
      overflow: "auto",
      flex: "0 1 auto",
      marginTop: theme.spacing(3),
      color: theme.palette.text.primary,
      background: theme.palette.background.paper,
      "&.ag-theme-material": {
        fontSize: "14px",
      },
      "&.ag-theme-material .ag-root-wrapper": {
        height: "100%",
      },
      "&.ag-theme-material .ag-body-viewport": {
        overflow: "auto",
      },
      "&.ag-theme-material .ag-root-wrapper-body": {
        height: "100%",
        transition: `filter ease-in ${CHANGE_DATA_TIMEOUT}s`,
      },
      [`&.ag-theme-material.${TABLE_LOADING_CLASS} .ag-root-wrapper-body`]: {
        transitionTimingFunction: "ease-out",
      },
      "&.ag-theme-material .ag-header": {
        color: theme.palette.text.primary,
        background: theme.palette.background.paper,
        borderBottomColor: "rgba(43, 57, 64, 0.3)", //TODO: Вынести в тему.
      },
      "&.ag-theme-material .ag-header .ag-header-cell-label": {
        justifyContent: "flex-start",
      },
      "&.ag-theme-material .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:hover": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell.ag-column-resizing": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:hover": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-cell:not(.ag-column-resizing) + .ag-header-cell.ag-column-resizing": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-group-cell:first-of-type:hover": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-group-cell:first-of-type.ag-column-resizing": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-cell:first-of-type:hover": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-cell:first-of-type.ag-column-resizing": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-cell": {
        transition: "background-color ease-in-out 0.1s",
        borderTop: "none",
        borderBottom: "none",
        lineHeight: "32px",
      },
      "&.ag-theme-material .cell_highlight": {
        outlineOffset: "-2px",
        outline: "solid",
        outlineWidth: "2px",
        outlineColor: theme.palette.primary.main,
      },
      "&.ag-theme-material .ag-row": {
        borderColor: "#eaebec", //TODO: Вынести в тему.
      },
      "&.ag-theme-material .row_highlight": {
        outlineOffset: "-2px",
        outline: "solid",
        outlineWidth: "2px",
        outlineColor: theme.palette.primary.main,
      },
      "&.ag-theme-material .ag-row.ag-row-odd": {
        borderColor: "#f0f1f2", //TODO: Вынести в тему.
        backgroundColor: "rgba(43, 57, 64, 0.03)", //TODO: Вынести в тему.
      },
      "&.ag-theme-material:not(.ag-theme-use-row-hovers) .ag-row.ag-row-odd.ag-row-hover": {
        backgroundColor: "rgba(43, 57, 64, 0.03)", //TODO: Вынести в тему.
      },
      "&.ag-theme-material .group-heading-row": {
        background: theme.palette.action.hover,
      },
      "&.ag-theme-material .period-header-highlited": {
        background: theme.palette.primary.main,
      },
      "&.ag-theme-material .period-cell-highlited": {
        fontWeight: "bold",
      },
      "&.ag-theme-material:not(.ag-theme-use-column-hovers) .ag-header-cell.ag-column-hover:hover": {
        backgroundColor: "inherit",
      },
      "&.ag-theme-material.ag-theme-use-column-hovers .ag-column-hover": {
        backgroundColor: theme.palette.secondary.light,
      },
      "&.ag-theme-material:not(.ag-theme-use-row-hovers) .ag-row-hover": {
        backgroundColor: "inherit",
      },
      "&.ag-theme-material.ag-theme-use-row-hovers .ag-row-hover": {
        backgroundColor: theme.palette.primary.light,
      },
      "&.ag-theme-material.ag-theme-use-row-hovers .ag-row-hover .ag-cell": {
        backgroundColor: theme.palette.action.hover,
      },
      "&.ag-theme-material .ag-header-cell": {
        fontWeight: "normal",
        color: "rgba(43, 57, 64, 0.5)", //TODO: Вынести в тему.
      },
      "&.ag-theme-material .ag-tooltip-custom": {
        position: "absolute",
      },
      [`&.ag-theme-material.${TABLE_LOADING_CLASS} .ag-root-wrapper-body`]: {
        filter: "blur(50px) opacity(0)",
      },
      [`&.ag-theme-material.${TABLE_LOADING_CLASS} .ag-root .ag-body-viewport > div`]: {
        overflow: "hidden",
      },
      [`&.ag-theme-material.${TABLE_LOADING_CLASS} .ag-root .ag-body-horizontal-scroll`]: {
        display: "none",
      },
      [`&.ag-theme-material .ag-popup > .ag-tooltip-custom.${TOOLTIP_ANIMATION_CLASS}`]: {
        transition: `transform ease-in-out ${TOOLTIP_ANIMATION_DURATION}s, width ease-in-out ${TOOLTIP_ANIMATION_DURATION}s, height ease-in-out ${TOOLTIP_ANIMATION_DURATION}s`,
      },
    },
  });

export interface AgGridTableHovers {
  columns?: boolean;
  rows?: boolean;
}

export interface AgGridTableOptions {
  useHovers?: AgGridTableHovers;
  rootClassName?: string;
}

interface AgGridTableProps {
  className?: string;
  loading: boolean;
  columnDefs: ColDef[];
  rowData: object[];
  getCustomPopupParentElement?: () => HTMLDivElement | null;
  options?: AgGridTableOptions;
  gridOptions?: GridOptions;
  onGridReady?: (event: GridReadyEvent, rootTableNode?: HTMLDivElement) => void;
  onRowDataChanged?: (params: RowDataChangedEvent, rootTableNode?: HTMLDivElement) => void;
  onTooltipRendered?: (tooltipElement: HTMLDivElement) => void;
  onPopupUnmount?: (popupElement: HTMLDivElement) => void;
  onResize?: () => void;
  getRowClass?: (params: any) => string;
  getCellClass?: (params: any) => string;
}

type Props = AgGridTableProps & WithStyles<typeof styles>;

const getDefaultRowClass = (params: any) => {
  return params.data.groupHeadingRow ? "group-heading-row" : "";
};

const DEFAULT_GRID_OPTIONS: GridOptions = {
  groupHeaderHeight: 56,
  rowHeight: 24,
  defaultColDef: { suppressMovable: true },
  frameworkComponents: {
    [BASE_TOOLTIP_COMPONENT_ID]: AgGridTableBaseTooltip,
    [STANDARD_TOOLTIP_COMPONENT_ID]: AgGridTableStandardTooltip,
  },
  domLayout: "autoHeight",
};

interface AgGridTableRef extends AgGridTable {
  eGridDiv: HTMLDivElement;
}

class AgGridTable extends React.Component<Props> {
  private _tableRootNode?: HTMLDivElement;
  private _popupParentElementObserver?: MutationObserver;
  private _dataUpdating: boolean = false;
  private _api: GridApi | undefined;

  state = {
    animation: false,
  };

  render() {
    const { rowData, options = {}, getCellClass } = this.props;
    const { useHovers } = options;

    const getRowClass = (params: any) => {
      const defaultClass = getDefaultRowClass(params);
      const customClass = this.props.getRowClass && this.props.getRowClass(params);
      if (customClass) {
        return `${defaultClass} ${customClass}`;
      }
      return defaultClass;
    };

    const styleOptions = this.props.getCellClass ? { getRowClass, cellClass: getCellClass } : { getRowClass };

    const agGridOptions = merge({}, DEFAULT_GRID_OPTIONS, styleOptions, this.props.gridOptions);
    this.removeDuplicateHandlers(agGridOptions);

    return (
      <div
        className={cn(this.props.className, this.props.classes.root, "ag-theme-material", options.rootClassName, {
          "ag-theme-use-column-hovers": useHovers?.columns,
          "ag-theme-use-row-hovers": useHovers?.rows,
          [TABLE_LOADED_CLASS]: rowData.length || this.props.loading,
          [TABLE_LOADING_CLASS]: this.state.animation || this.props.loading,
        })}
      >
        <AgGridReact
          suppressRowTransform={true}
          ref={(table: AgGridTableRef) => (this._tableRootNode = table && table.eGridDiv)}
          columnDefs={this.props.columnDefs}
          rowData={rowData}
          gridOptions={agGridOptions}
          onGridReady={this.handleOnGridReady}
          onRowDataChanged={this.handleOnRowDataChanged}
        />
      </div>
    );
  }

  componentDidUpdate(nextProps: Props) {
    const { columnDefs, rowData, getRowClass, getCellClass } = this.props;
    if (nextProps.columnDefs !== columnDefs || nextProps.rowData !== rowData) {
      this._dataUpdating = true;
      this.animation();
    }

    try {
      if (getCellClass !== nextProps.getCellClass) {
        const prevColumnDefs = (this._api as any)?.getColumnDefs();
        if (prevColumnDefs) {
          const newColumnDefs = nextProps.columnDefs.map((columnDef) => ({ ...columnDef, cellClass: this.props.getCellClass }));
          this._api?.setColumnDefs([]);
          this._api?.setColumnDefs(newColumnDefs);
          this._api?.sizeColumnsToFit();
        }
      } else {
        const columnsDefs = nextProps.columnDefs.map((columnDef) => ({ ...columnDef, cellClass: this.props.getCellClass }));
        this._api?.setColumnDefs([]);
        this._api?.setColumnDefs(columnsDefs);
        this._api?.sizeColumnsToFit();
      }
      if (getRowClass !== nextProps.getRowClass) {
        this._api?.redrawRows();
      }
    } catch (err) {
      console.error(err);
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
    this._popupParentElementObserver?.disconnect();
  }

  protected animation() {
    this.setState({ animation: true });
    setTimeout(() => {
      this.setState({ animation: false });
      this._api?.sizeColumnsToFit();
    }, 200);
  }

  private initCustomPopupParentElementObserver = () => {
    const { getCustomPopupParentElement } = this.props;
    const customPopupParentElement = getCustomPopupParentElement && getCustomPopupParentElement();
    if (customPopupParentElement) {
      const observer = (this._popupParentElementObserver = new MutationObserver(this.handlePopupChange));
      observer.observe(customPopupParentElement!, { childList: true });
    }
  };

  private removeDuplicateHandlers = (gridOptions: GridOptions) => {
    delete gridOptions.onGridReady;
    delete gridOptions.onRowDataChanged;
  };

  private handleOnGridReady = (params: GridReadyEvent) => {
    try {
      const { onGridReady } = this.props;
      this._api = params.api;
      window['gridApi'] = this._api;
      if (onGridReady) {
        onGridReady(params, this._tableRootNode);
        this.initCustomPopupParentElementObserver();
      }
      params.api.sizeColumnsToFit();
    } finally {
    }
  };

  private handleOnRowDataChanged = (params: RowDataChangedEvent) => {
    if (!this._dataUpdating) {
      return;
    }
    this._dataUpdating = false;
    try {
      const { onRowDataChanged } = this.props;
      if (onRowDataChanged) {
        onRowDataChanged(params, this._tableRootNode);
      }
    } finally {
    }
  };

  private handleWindowResize = () => {
    this._api?.sizeColumnsToFit();
    const { onResize } = this.props;
    if (onResize) {
      onResize();
    }
  };

  private handlePopupChange = (mutations: MutationRecord[], observer: MutationObserver) => {
    const { onTooltipRendered, onPopupUnmount } = this.props;
    if (!(onTooltipRendered || onPopupUnmount)) {
      return;
    }
    for (const mutation of mutations) {
      if (onTooltipRendered) {
        const addedTooltipElement = this.findElement(mutation.addedNodes, "ag-tooltip-custom");
        if (addedTooltipElement) {
          onTooltipRendered(addedTooltipElement);
        }
      }
      if (onPopupUnmount) {
        const removedPopupElement = this.findElement(mutation.removedNodes, "ag-popup");
        if (removedPopupElement) {
          onPopupUnmount(removedPopupElement);
        }
      }
    }
  };

  private findElement = (nodes: NodeList, className: string) => {
    return Array.from(nodes).find((node) => (node as HTMLDivElement).classList.contains(className)) as
      | HTMLDivElement
      | undefined;
  };
}

export default withStyles(styles)(AgGridTable);
